export function Chaff() {
  return <span style={{ position: "absolute", left: "-99vw" }}>____</span>
}
